export default __webpack_public_path__ + "static/media/DescribingPeople_11.73cc3865.png";